import { render, staticRenderFns } from "./EditHookUpdated.vue?vue&type=template&id=d27da1ec&"
import script from "./EditHookUpdated.vue?vue&type=script&lang=js&"
export * from "./EditHookUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports